import React, { Component } from "react";
import Header from "./common/Header";
import Footer from "./common/Footer";

export default class Site extends Component {
  render() {
    return (
      <div className="site bg-white">
        <Header></Header>
        <div className="site-wrapper">{this.props.children}</div>
        <Footer></Footer>
      </div>
    );
  }
}
